var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3434 2.95035C10.207 2.81391 9.98525 2.81391 9.84882 2.95035L5.49998 7.30771L1.14261 2.95035C1.00618 2.81391 0.784475 2.81391 0.648041 2.95035C0.511607 3.08678 0.511607 3.30849 0.648041 3.44492L5.24417 8.04105C5.31238 8.10926 5.39765 8.14337 5.49145 8.14337C5.57672 8.14337 5.67052 8.10926 5.73874 8.04105L10.3349 3.44492C10.4798 3.30849 10.4798 3.08678 10.3434 2.95035Z",
    fill: "#07AFF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow-down-icon.659cac327b533b57fa6e94f69182d057.svg";
export { ForwardRef as ReactComponent };